export const DEFAULT_VALUE_TEXT = 'Not provided';
